import { Button, Dropdown, MenuProps, Row } from "antd";
import { DownOutlined } from "@ant-design/icons";
import { useCallback, useMemo, useState } from "react";
import { ExportModal } from "../ExportModal";
import { useExportCheckPayments } from "../hooks/useExportCheckPayments";

type ExportDropdownProps = {
  request: any;
};

export const ExportDropdown = ({ request }: ExportDropdownProps) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);

  const openACHModal = useCallback(() => setIsOpen(true), []);

  const { onExportCheck, isLoading } = useExportCheckPayments(request);

  const items: MenuProps["items"] = useMemo(
    () => [
      {
        key: 1,
        label: (
          <Row id="1" onClick={onExportCheck}>
            Check Payments
          </Row>
        ),
      },
      {
        key: 2,
        label: (
          <Row id="2" onClick={openACHModal}>
            ACH Payments
          </Row>
        ),
      },
    ],
    [openACHModal, onExportCheck]
  );

  return (
    <>
      <Dropdown menu={{ items }} trigger={["click"]} disabled={isLoading}>
        <Button shape="round" className="ml-4 d-inline-flex align-center">
          Export <DownOutlined />
        </Button>
      </Dropdown>

      <ExportModal isOpen={isOpen} setIsOpen={setIsOpen} />
    </>
  );
};
